import React from 'react';
import { CheckIcon } from 'lucide-react';
import { packages } from '../data/packages';
import { StartCta } from './CtaButton';
export function Pricing() {
  return <section className="bg-brand-light" aria-labelledby="pricing-heading" data-id="element-98" data-mp="2aphrx7khw7y9">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20 lg:py-24" data-id="element-99" data-mp="2ohxp3rqptbr9">
        <div className="max-w-2xl" data-id="element-100" data-mp="2jkxj1gtv8905">
          <h2 id="pricing-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-101" data-mp="2jlyu3lavsvhv">
            Two ways to launch
          </h2>
          <p className="mt-4 text-base leading-relaxed text-brand-gray" data-id="element-102" data-mp="1rusyni63vlyx">
            Same 72-hour build, same Slack-and-AI changes. Pilot adds the 24/7 AI phone attendant,
            review automation, and full CRM on top.
          </p>
        </div>

        <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-103" data-mp="3h63amgplf4s5">
          {packages.map(pkg => {
          const featured = pkg.featured;
          return <article key={pkg.id} className={`relative flex flex-col bg-brand-white ${featured ? 'border-2 border-brand-red shadow-[0_0_0_6px_rgba(188,33,39,0.12)]' : 'border border-brand-black/10'}`} data-id="element-104" data-mp="3w08ck3pope89">
                {pkg.badge ? <p className="bg-brand-red px-6 py-2.5 text-center font-display text-[11px] font-bold uppercase tracking-[0.18em] text-brand-white sm:text-xs" data-id="element-105" data-mp="eoz4jei2lzos">
                    {pkg.badge}
                  </p> : <p className="border-b border-brand-light px-6 py-2.5 text-center font-display text-[11px] font-bold uppercase tracking-[0.18em] text-brand-gray sm:text-xs" data-id="element-106" data-mp="3n6v9i8xwow8g">
                    Get online
                  </p>}

                <div className="flex flex-1 flex-col p-7 sm:p-9" data-id="element-107" data-mp="2ugdabj0azf0b">
                  <h3 className="font-display text-2xl font-extrabold uppercase tracking-[0.12em]" data-id="element-108" data-mp="2zg9fvmonfehz">
                    {pkg.name}
                  </h3>

                  <p className="mt-5 flex items-baseline gap-2" data-id="element-109" data-mp="2mhrxy2h0869z">
                    <span className={`font-display text-5xl font-extrabold leading-none tracking-tight sm:text-6xl ${featured ? 'text-brand-red' : 'text-brand-black'}`} data-id="element-110" data-mp="2mhi5874krl0l">
                      {pkg.monthly}
                    </span>
                    <span className="text-sm font-semibold text-brand-gray" data-id="element-111" data-mp="23ixfaief6loj">/month</span>
                  </p>

                  <dl className="mt-7 border-y border-brand-light py-5 text-sm" data-id="element-112" data-mp="2ifwvuvr91ov5">
                    <div className="flex items-baseline justify-between gap-4" data-id="element-113" data-mp="2idtwvm84clea">
                      <dt className="text-brand-gray" data-id="element-114" data-mp="2dfsfd5qccu4x">White Glove Onboarding</dt>
                      <dd className="flex items-baseline gap-2 text-right font-semibold" data-id="element-115" data-mp="3tts9g02i9pk9">
                        <span className="text-brand-gray line-through" data-id="element-116" data-mp="3ovgytn4dzb0z">
                          {pkg.onboardingStandard}
                        </span>
                        <span className={featured ? 'text-brand-red' : 'text-brand-black'} data-id="element-117" data-mp="59gr6e6vm5sk">
                          {pkg.onboardingOffer}
                        </span>
                      </dd>
                    </div>
                    <div className="mt-3.5 flex items-baseline justify-between gap-4" data-id="element-118" data-mp="3rfwubmtp1gpc">
                      <dt className="font-bold text-brand-black" data-id="element-119" data-mp="j14y8329q42o">Total due to start</dt>
                      <dd className="font-display text-lg font-extrabold" data-id="element-120" data-mp="nzydo114855h">
                        {pkg.totalDueToStart}
                      </dd>
                    </div>
                    <div className="mt-2 flex items-baseline justify-between gap-4" data-id="element-121" data-mp="a6gy0rbjvckq">
                      <dt className="text-brand-gray" data-id="element-122" data-mp="e8ll177htaye">Then</dt>
                      <dd className="font-semibold text-brand-black" data-id="element-123" data-mp="11zhavyse1w30">{pkg.monthly}/mo</dd>
                    </div>
                    <p className="mt-3 text-xs text-brand-gray" data-id="element-124" data-mp="16rhf43fhrb5e">3-month minimum term.</p>
                  </dl>

                  <p className="mt-6 text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-125" data-mp="3f93ga0rgvlnh">
                    {pkg.featuresHeading}
                  </p>
                  <ul className="mt-4 space-y-3 text-sm leading-relaxed" data-id="element-126" data-mp="358t3uid9ai9d">
                    {pkg.features.map(feature => <li key={feature} className="flex gap-3" data-id="element-127" data-mp="3192bia82zu2q">
                        <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-red" aria-hidden="true" data-id="element-128" data-mp="1t5e7hhdep9c" />
                        <span data-id="element-129" data-mp="3o7ylpamosrpq">{feature}</span>
                      </li>)}
                  </ul>

                  <div className="mt-auto pt-8" data-id="element-130" data-mp="3k74uo8dy6wsm">
                    <StartCta className="w-full" data-id="element-131" data-mp="3k6d3ravapn8o" />
                  </div>
                </div>
              </article>;
        })}
        </div>

        <p className="mx-auto mt-8 max-w-3xl text-center text-sm leading-relaxed text-brand-gray" data-id="element-132" data-mp="fs52go0z124z">
          Starting Launch costs $814. Starting Pilot costs $1,114 —{' '}
          <span className="font-semibold text-brand-black" data-id="element-133" data-mp="23dye03uvw8z6">
            just $300 more to start, for a lot more package.
          </span>
        </p>
      </div>
    </section>;
}